import { ISelectComPesquisaProps, SelectComPesquisa } from "../../../../SelectComPesquisa";
export interface ITipoConsultaDataSelectProps extends ISelectComPesquisaProps {

}
export default function TipoConsultaDataSelect({
    placeholder,
    ...props
}:ITipoConsultaDataSelectProps) {
    return <SelectComPesquisa 
        {...props}
        placeholder={placeholder ?? "Selecione"}
        options={[
            {
                value : 1,
                label : "Vencimento"
            },
            {
                value : 2,
                label : "Criação"
            },
            {
                value : 3,
                label : "Pagamento"
            }//,
            // {
            //     value : 4,
            //     label : "Credito"
            // }
        ]}
    />
}